<LocationForm :post-save-action="add" :show-buttons="false" :two-column-layout="false"></LocationForm>